module.exports = __webpack_public_path__ + "img/lan.dabacb9a.png";